function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 0A4.35 4.35 0 00.654 4.346c0 2.974 3.89 7.34 4.055 7.524a.391.391 0 00.582 0c.166-.184 4.055-4.55 4.055-7.524A4.35 4.35 0 005 0zm0 6.532a2.189 2.189 0 01-2.187-2.186c0-1.206.981-2.187 2.187-2.187 1.205 0 2.186.981 2.186 2.187S6.206 6.532 5 6.532z",
  fill: "#0785FE"
});

function SvgPointAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    fill: "none"
  }, props), _ref);
}

export default SvgPointAddress;